import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "c-single-car-features__list"
}
const _hoisted_2 = {
  key: 0,
  class: "c-single-car-features__list__item"
}
const _hoisted_3 = { class: "c-single-car-features__list__text" }
const _hoisted_4 = {
  key: 1,
  class: "c-single-car-features__list__item"
}
const _hoisted_5 = { class: "c-single-car-features__list__text" }
const _hoisted_6 = {
  key: 2,
  class: "c-single-car-features__list__item"
}
const _hoisted_7 = { class: "c-single-car-features__list__text" }
const _hoisted_8 = { class: "c-single-car-features__list__item" }
const _hoisted_9 = { class: "c-single-car-features__list__text" }
const _hoisted_10 = {
  key: 3,
  class: "c-single-car-features__list__item"
}
const _hoisted_11 = {
  key: 4,
  class: "c-single-car-features__list__item"
}
const _hoisted_12 = {
  key: 5,
  class: "c-single-car-features__list__item"
}
const _hoisted_13 = {
  key: 6,
  class: "c-single-car-features__list__item"
}
const _hoisted_14 = {
  key: 7,
  class: "c-single-car-features__list__item"
}
const _hoisted_15 = { class: "c-single-car-features__list__text" }
const _hoisted_16 = {
  key: 8,
  class: "c-single-car-features__list__item"
}
const _hoisted_17 = { class: "c-single-car-features__list__text" }
const _hoisted_18 = {
  key: 9,
  class: "c-single-car-features__list__item"
}
const _hoisted_19 = { class: "c-single-car-features__list__text" }
const _hoisted_20 = {
  key: 10,
  class: "c-single-car-features__list__item"
}
const _hoisted_21 = { class: "c-single-car-features__list__text" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svgIco = _resolveComponent("svgIco")

  return ($data.loaded)
    ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
        ($data.currentTrim.moteur)
          ? (_openBlock(), _createElementBlock("li", _hoisted_2, [
              _createVNode(_component_svgIco, { icon: "moteur" }),
              _createElementVNode("div", _hoisted_3, [
                _cache[0] || (_cache[0] = _createElementVNode("strong", null, "Moteur", -1 /* HOISTED */)),
                _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1 /* HOISTED */)),
                _createElementVNode("span", null, _toDisplayString($data.currentTrim.moteur), 1 /* TEXT */)
              ])
            ]))
          : _createCommentVNode("v-if", true),
        ($data.currentTrim.power)
          ? (_openBlock(), _createElementBlock("li", _hoisted_4, [
              _createVNode(_component_svgIco, { icon: "puissance" }),
              _createElementVNode("div", _hoisted_5, [
                _cache[2] || (_cache[2] = _createElementVNode("strong", null, "Puissance", -1 /* HOISTED */)),
                _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1 /* HOISTED */)),
                _createElementVNode("span", null, _toDisplayString($data.currentTrim.power), 1 /* TEXT */)
              ])
            ]))
          : _createCommentVNode("v-if", true),
        ($options.getWheels())
          ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
              _createVNode(_component_svgIco, { icon: "rouage" }),
              _createElementVNode("div", _hoisted_7, [
                _cache[4] || (_cache[4] = _createElementVNode("strong", null, "Rouage", -1 /* HOISTED */)),
                _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1 /* HOISTED */)),
                _createElementVNode("span", null, _toDisplayString($options.getWheels()), 1 /* TEXT */)
              ])
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("li", _hoisted_8, [
          _createVNode(_component_svgIco, { icon: "transmission" }),
          _createElementVNode("div", _hoisted_9, [
            _cache[6] || (_cache[6] = _createElementVNode("strong", null, "Transmission", -1 /* HOISTED */)),
            _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1 /* HOISTED */)),
            _createElementVNode("span", null, _toDisplayString($data.currentTrim.name.match(/BM/) || $data.currentTrim.name.match(/BVM/) ? 'Manuelle' : 'Automatique'), 1 /* TEXT */)
          ])
        ]),
        ($data.currentTrim.icone=='gas')
          ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
              _createVNode(_component_svgIco, { icon: "carburant-essence" }),
              _cache[8] || (_cache[8] = _createElementVNode("div", { class: "c-single-car-features__list__text" }, [
                _createElementVNode("strong", null, "Carburant"),
                _createElementVNode("br"),
                _createElementVNode("span", null, "Essence")
              ], -1 /* HOISTED */))
            ]))
          : _createCommentVNode("v-if", true),
        ($data.currentTrim.icone=='hybrid')
          ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
              _createVNode(_component_svgIco, {
                icon: "carburant-hybride",
                class: "-hybride"
              }),
              _cache[9] || (_cache[9] = _createElementVNode("div", { class: "c-single-car-features__list__text" }, [
                _createElementVNode("strong", null, "Carburant"),
                _createElementVNode("br"),
                _createElementVNode("span", null, "Hybride")
              ], -1 /* HOISTED */))
            ]))
          : _createCommentVNode("v-if", true),
        ($data.currentTrim.icone=='recharge')
          ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
              _createVNode(_component_svgIco, {
                icon: "carburant-hybride-rechargeable",
                class: "-hybride-recharge"
              }),
              _cache[10] || (_cache[10] = _createElementVNode("div", { class: "c-single-car-features__list__text" }, [
                _createElementVNode("strong", null, "Carburant"),
                _createElementVNode("br"),
                _createElementVNode("span", null, "Hybride rechargeable")
              ], -1 /* HOISTED */))
            ]))
          : _createCommentVNode("v-if", true),
        ($data.currentTrim.icone=='electric')
          ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
              _createVNode(_component_svgIco, { icon: "carburant-electrique" }),
              _cache[11] || (_cache[11] = _createElementVNode("div", { class: "c-single-car-features__list__text" }, [
                _createElementVNode("strong", null, "Carburant"),
                _createElementVNode("br"),
                _createElementVNode("span", null, "Électrique")
              ], -1 /* HOISTED */))
            ]))
          : _createCommentVNode("v-if", true),
        ($data.currentTrim.gas)
          ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
              _createVNode(_component_svgIco, { icon: "consommation-essence" }),
              _createElementVNode("div", _hoisted_15, [
                _cache[12] || (_cache[12] = _createElementVNode("strong", null, "Consommation", -1 /* HOISTED */)),
                _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1 /* HOISTED */)),
                _createElementVNode("span", null, _toDisplayString($data.currentTrim.gas), 1 /* TEXT */),
                _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1 /* HOISTED */)),
                _cache[15] || (_cache[15] = _createElementVNode("span", null, "Ville/Autoroute (L/100km)", -1 /* HOISTED */))
              ])
            ]))
          : _createCommentVNode("v-if", true),
        ($data.currentTrim.auto)
          ? (_openBlock(), _createElementBlock("li", _hoisted_16, [
              _createVNode(_component_svgIco, { icon: "autonomie" }),
              _createElementVNode("div", _hoisted_17, [
                _cache[16] || (_cache[16] = _createElementVNode("strong", null, "Autonomie", -1 /* HOISTED */)),
                _cache[17] || (_cache[17] = _createElementVNode("br", null, null, -1 /* HOISTED */)),
                _createElementVNode("span", null, _toDisplayString($data.currentTrim.auto), 1 /* TEXT */)
              ])
            ]))
          : _createCommentVNode("v-if", true),
        _createCommentVNode("li class=\"c-single-car-features__list__item\">\n            <svgIco icon='garantie' />\n            <div class=\"c-single-car-features__list__text\">\n                <strong>Garantie</strong><br>\n                <span>3 ans/60 000 km</span>\n            </div>\n        </li"),
        ($options.getCabine())
          ? (_openBlock(), _createElementBlock("li", _hoisted_18, [
              _createVNode(_component_svgIco, {
                icon: "camion-cabine",
                class: "-camion"
              }),
              _createElementVNode("div", _hoisted_19, [
                _cache[18] || (_cache[18] = _createElementVNode("strong", null, "Cabine", -1 /* HOISTED */)),
                _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1 /* HOISTED */)),
                _createElementVNode("span", null, _toDisplayString($options.getCabine()), 1 /* TEXT */)
              ])
            ]))
          : _createCommentVNode("v-if", true),
        ($options.getCaisse())
          ? (_openBlock(), _createElementBlock("li", _hoisted_20, [
              _createVNode(_component_svgIco, {
                icon: "camion-boite",
                class: "-camion"
              }),
              _createElementVNode("div", _hoisted_21, [
                _cache[20] || (_cache[20] = _createElementVNode("strong", null, "Caisse", -1 /* HOISTED */)),
                _cache[21] || (_cache[21] = _createElementVNode("br", null, null, -1 /* HOISTED */)),
                _createElementVNode("span", null, _toDisplayString($options.getCaisse()), 1 /* TEXT */)
              ])
            ]))
          : _createCommentVNode("v-if", true),
        _createCommentVNode("li class=\"c-single-car-features__list__item\">\n            <svgIco icon='camion-chassis' class='-camion' />\n            <div class=\"c-single-car-features__list__text\">\n                <strong>Chassis</strong><br>\n                <span>{{ 'x' }}</span>\n            </div>\n        </li")
      ]))
    : _createCommentVNode("v-if", true)
}